import { FormHelperText as MuiFormHelperText } from '@mui/material';

import { useColors } from '../ThemeProvider/useColors';

type Props = {
  id: string;
  showError: boolean;
  text: string | undefined;
  disabled?: boolean;
};

export function FormHelperText({ id, showError, text, disabled = false }: Props) {
  const { errorDark, textSecondary } = useColors();
  const helperColor = showError ? errorDark : textSecondary;

  return (
    !!text && (
      <MuiFormHelperText
        id={id}
        sx={{
          color: helperColor,
          ml: 0,
          fontSize: '0.875rem',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          opacity: disabled ? 0.7 : 1,
        }}
      >
        {text}
      </MuiFormHelperText>
    )
  );
}
